import axios from "axios";
import {AxiosRequestConfig} from "axios";

export interface AxiosRequestResult<T> {
   data: T
   status: number
   statusText: string
}

export const AxiosRequest = async <T>(payload: Omit<AxiosRequestConfig<any>, 'validateStatus'|'timeout'>, failOnError?: boolean): Promise<AxiosRequestResult<T>> => {
   const {data, status, statusText} = await axios.request({
      ...payload,
      timeout: 60000,
      validateStatus: (status) => true
   });

   if (status >= 300 && (failOnError===undefined || failOnError)) {
      if (data.errors) {
         const error = JSON.stringify(data.errors)
         throw new Error(error)
      } else {
         console.error(data, status, statusText);
         throw new Error('Request failed with ' + statusText)
      }
   }
   return {
      data,
      status,
      statusText
   };
}